import React, {useEffect, useState} from 'react';
import {EnumPlanObdobi, PlanDetailVO, PlanVO, SettingsApi, SouhrnApi} from '../api';
import {PLAN, PRUBEH, SKUTECNOST} from '../enums/PohledTypeEnum';
import {Col, Row, Spinner} from 'react-bootstrap';
import {LineChartData} from '../types/LineChartData';
import {getMonth} from '../utils/NumberUtils';
import {LineChart} from './LineChart';
import {DonutChart} from './DonutChart';
import {SouhrnDetail} from './SouhrnDetail';
import {DonutChartData} from '../types/DonutChartData';

interface SouhrnPanelProps {
    planObdobi: string;
    idVerze: string;
}

export const SouhrnPanel: React.FC<SouhrnPanelProps> = ({planObdobi, idVerze}) => {
    const [plans, setPlans] = useState<PlanVO[]>([]);
    const [comment, setComment] = useState<string>();
    const [planDetails, setPlanDetails] = useState<PlanDetailVO[]>([]);
    const [fetching, setFetching] = useState(false);

    useEffect(() => {
        loadSourhn();
    }, [planObdobi, idVerze]);

    const loadSourhn = () => {
        const fetchData = async () => {
            let fPlans: PlanVO[] = [];
            let fDetails: PlanDetailVO[] = [];
            try {
                setFetching(true);

                fDetails = (await SouhrnApi.getPrubeh(parseInt(idVerze))).data;
                setPlanDetails(fDetails);

                const obdobiEnum = planObdobi === PLAN ? EnumPlanObdobi.PLAN : EnumPlanObdobi.SKUTECNOST;
                fPlans = (await SouhrnApi.getSouhrn(parseInt(idVerze), obdobiEnum)).data;
                setPlans(fPlans);

                const kom = (await SouhrnApi.getKomentar()).data;
                setComment(kom);

                setFetching(false);
            } catch (error) {
                // TODO
            }
        };
        fetchData();
    };

    if (fetching || plans.length === 0 || planDetails.length === 0) {
        return (
            <div className="loading-data">
                <Spinner animation="border" role="status" style={{marginRight: 10}} />
                Načítání dat...
            </div>
        );
    }

    const koreny = plans.filter(item => item.idPlanOt === null);

    let charts;
    if (planObdobi === PRUBEH) {
        charts = koreny.map(koren => {
            const prubehData: LineChartData[] = [];
            planDetails
                .filter(item => item.idPlan == koren.idPlan)
                .forEach(item => {
                    prubehData.push({value: item.skutecnnost, dataType: 'Skutečnost', timestamp: getMonth(item.mesic)});
                    prubehData.push({value: item.upravenyRozpocet, dataType: 'Upravený rozpočet', timestamp: getMonth(item.mesic)});
                    prubehData.push({value: item.schvalenyRozpocet, dataType: 'Schválený rozpočet', timestamp: getMonth(item.mesic)});
                });
            return <LineChart title={koren.nazevAkce ? koren.nazevAkce : ''} data={prubehData} reduce={koreny.length > 2} />;
        });
    } else {
        charts = koreny.map(koren => {
            // @ts-ignore
            const chartData: DonutChartData[] = plans
                .filter(item => item.idPlanOt == koren.idPlan)
                .map(item => {
                    const value = planObdobi === SKUTECNOST ? item.skutecnnost : item.upravenyRozpocet;
                    return {value: value === undefined ? 0 : Math.abs(value) / 1000, type: item.nazevAkce, idPlan: item.idPlan};
                });
            return <DonutChart title={koren.nazevAkce ? koren.nazevAkce : ''} idVerze={idVerze} data={chartData} reduce={koreny.length > 2} />;
        });
    }

    return (
        <div style={{padding: 20}}>
            <Row>
                {charts.map((chart, index) => {
                    return (
                        <Col key={'chart' + index} xxl={charts.length === 2 ? 6 : 4} lg={6} xs={12}>
                            <div>
                                <div style={{paddingLeft: 20, paddingTop: 20}}>
                                    <SouhrnDetail plan={koreny[index]} skutecnost={planObdobi === SKUTECNOST} />
                                </div>
                                <div style={{paddingTop: 20}} className="centered">
                                    {chart}
                                </div>
                            </div>
                        </Col>
                    );
                })}
            </Row>
            {comment && <Row style={{padding: 50}}>{comment}</Row>}
        </div>
    );
};
